"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Switch = _interopRequireDefault(require("../Form/Switch"));

var _Expando = require("../Expando");

var _TextField = _interopRequireDefault(require("../Form/TextField"));

var _SelectField = _interopRequireDefault(require("../Form/SelectField"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = _interopRequireDefault(require("../Button"));

var _FilterList = _interopRequireDefault(require("./FilterList"));

var _useFilterReducer3 = _interopRequireDefault(require("./util/useFilterReducer"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SwitchFilter = function SwitchFilter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      title = _ref.title,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      flipSwitch = _ref.flipSwitch;
  return /*#__PURE__*/_react.default.createElement(_Switch.default, {
    size: size,
    label: title,
    checked: checked,
    onChange: flipSwitch
  });
};

var PanelTab = function PanelTab(_ref2) {
  var toggle = _ref2.toggle,
      open = _ref2.open;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "PanelTab",
    onClick: function onClick() {
      toggle();
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "chevron-".concat(open ? 'left' : 'right')
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "search"
  }));
};

var FiltersToggler = function FiltersToggler(_ref3) {
  var toggle = _ref3.toggle,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'small' : _ref3$size;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "filter-toggler",
    onClick: toggle,
    icon: "filter",
    size: size
  }, "All Filters");
};

var SortOptions = function SortOptions(_ref4) {
  var state = _ref4.state,
      dispatch = _ref4.dispatch,
      sortOptions = _ref4.sortOptions,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'small' : _ref4$size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "is-flex sort-options"
  }, /*#__PURE__*/_react.default.createElement(_SelectField.default, {
    size: size,
    placeholder: "Sort by...",
    value: state.sortName,
    options: Object.keys(sortOptions).reduce(function (coll, k) {
      coll[k] = sortOptions[k].label;
      return coll;
    }, {}),
    onChange: function onChange(e) {
      dispatch({
        type: 'setSortName',
        sortName: e.target.value
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: size,
    icon: "chevron-circle-".concat(state.reverseSort ? 'up' : 'down'),
    onClick: function onClick() {
      dispatch({
        type: 'toggleSort'
      });
    }
  }));
};

var CollectionFilterWrapper = function CollectionFilterWrapper(_ref5) {
  var _ref5$className = _ref5.className,
      className = _ref5$className === void 0 ? '' : _ref5$className,
      data = _ref5.data,
      filters = _ref5.filters,
      switches = _ref5.switches,
      children = _ref5.children,
      stats = _ref5.stats,
      preSelectedOpts = _ref5.preSelectedOpts,
      onFilterChange = _ref5.onFilterChange,
      searchFilter = _ref5.searchFilter,
      searchPlaceholder = _ref5.searchPlaceholder,
      sortOptions = _ref5.sortOptions,
      externalControls = _ref5.externalControls,
      toggles = _ref5.toggles,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'small' : _ref5$size,
      _ref5$countLabel = _ref5.countLabel,
      countLabel = _ref5$countLabel === void 0 ? 'Results' : _ref5$countLabel;
  var usefulSwitches = switches.filter(function (_ref6) {
    var extractorFn = _ref6.extractorFn;
    return data.filter(extractorFn).length > 0;
  });

  var _useFilterReducer = (0, _useFilterReducer3.default)(filters.map(function (_ref7) {
    var name = _ref7.name;
    return name;
  }), switches, toggles, preSelectedOpts),
      _useFilterReducer2 = _slicedToArray(_useFilterReducer, 2),
      state = _useFilterReducer2[0],
      dispatch = _useFilterReducer2[1];

  var calculatedStats = (0, _util.calculateStats)(data, stats);

  var doUpdate = function doUpdate() {
    if (onFilterChange) {
      var _filters = state.filters,
          _switches = state.switches,
          searchString = state.searchString,
          sortName = state.sortName,
          reverseSort = state.reverseSort,
          _toggles = state.toggles;
      onFilterChange({
        filters: _filters,
        switches: _switches,
        searchString: searchString,
        sortName: sortName,
        reverseSort: reverseSort,
        toggles: _toggles
      });
    }
  };

  (0, _react.useEffect)(doUpdate, [state]);
  var hasFilters = filters.length > 0;
  var hasSwitches = usefulSwitches.length > 0;
  var hasToggles = toggles.length > 0; // if we are ever setting filters dynamically and we end up with
  // empty array or undefined this will ensure that the data still falls through
  // to the wrapped collection handler

  if (!hasFilters && !hasSwitches && !searchFilter && !sortOptions && !externalControls && !hasToggles) {
    return children({
      data: data,
      stats: calculatedStats
    });
  }

  var __switched = (0, _util.applySwitches)(data, switches, state.switches);

  var __toggled = (0, _util.applyAlternateToggles)(__switched, toggles, state.toggles);

  var __filtered = (0, _util.filterData)(__toggled, filters, state.filters);

  var __searched = (0, _util.applySearch)(state.searchString, searchFilter, __filtered);

  var __sorted = !sortOptions || state.sortName === '' ? __searched : sortOptions[state.sortName] ? __searched.sort(sortOptions[state.sortName].sortfn) : __searched;

  var filteredData = state.reverseSort ? __sorted.reverse() : __sorted;
  var filteredCounts = (0, _util.countData)(filteredData, data, filters);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "CollectionFilterWrapper ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_Expando.RawExpando, {
    defaultOpen: !window.matchMedia('screen and (max-width: 768px)').matches
  }, function (_ref8) {
    var toggle = _ref8.toggle,
        open = _ref8.open;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('FilterPanel', {
        open: open
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FilterPanel-inner"
    }, /*#__PURE__*/_react.default.createElement("h4", null, filteredCounts.total, " ", countLabel, /*#__PURE__*/_react.default.createElement("small", {
      className: "ResetLink",
      onClick: function onClick() {
        return dispatch({
          type: 'reset'
        });
      }
    }, "(Reset Filters)")), externalControls && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, externalControls), sortOptions && /*#__PURE__*/_react.default.createElement(SortOptions, {
      state: state,
      sortOptions: sortOptions,
      dispatch: dispatch
    }), searchFilter && /*#__PURE__*/_react.default.createElement(_TextField.default, {
      size: size,
      value: state.searchString,
      leftIcon: "search",
      placeholder: searchPlaceholder,
      onChange: function onChange(e) {
        return dispatch({
          type: 'updateSearchString',
          searchString: e.target.value
        });
      }
    }), /*#__PURE__*/_react.default.createElement(FiltersToggler, {
      toggle: toggle,
      open: open,
      size: size
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "switchesWrapper"
    }, usefulSwitches.map(function (s) {
      return /*#__PURE__*/_react.default.createElement(SwitchFilter, _extends({
        key: s.name,
        checked: state.switches[s.name],
        flipSwitch: function flipSwitch() {
          dispatch({
            type: 'flipSwitch',
            name: s.name
          });
        }
      }, s));
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "filtersWrapper"
    }, filters.map(function (filter) {
      var opts = (0, _util.deriveUniqueValues)(data, filter);

      if (opts.length > 0) {
        return /*#__PURE__*/_react.default.createElement(_FilterList.default, _extends({
          className: (0, _classnames.default)({
            open: open
          }),
          key: filter.name
        }, filter, {
          toggleFilter: function toggleFilter(name, option) {
            dispatch({
              type: 'toggleFilter',
              name: name,
              option: option
            });
          },
          checked: state.filters,
          options: opts,
          counts: filteredCounts[filter.name]
        }));
      } else {
        return null;
      }
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "DataContainer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "DataContainer-Controls"
    }, toggles.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "togglesWrapper"
    }, toggles.map(function (toggle, i) {
      if ((0, _isEmpty.default)(toggle)) return /*#__PURE__*/_react.default.createElement("hr", {
        key: i
      });
      var name = toggle.name,
          render = toggle.render,
          extractorFn = toggle.extractorFn,
          count = filteredData.filter(extractorFn).length,
          active = state.toggles[name];
      return /*#__PURE__*/_react.default.createElement("span", {
        key: i,
        className: (0, _classnames.default)('frikin-toggle', {
          'is-active': state.toggles[name]
        }),
        onClick: function onClick() {
          return dispatch({
            type: 'flipToggle',
            name: name
          });
        }
      }, render({
        count: count,
        active: active
      }));
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "DataContainer-Results"
    }, children({
      data: filteredData,
      stats: calculatedStats
    }))));
  }));
};

CollectionFilterWrapper.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  switches: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  searchFilter: _propTypes.default.func
};
CollectionFilterWrapper.defaultProps = {
  filters: [],
  data: [],
  switches: [],
  toggles: [],
  searchPlaceholder: ''
};
var _default = CollectionFilterWrapper;
exports.default = _default;